"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EskinMath = void 0;
/**
 * Formulas related to e-skin Ketten
 */
class EskinMath {
    /**
     * Calculates the minimal (not effective) length of the e-skin.
     * The effective length depends on the Teilung of a Glied.
     *
     * @param verfahrweg_mm The Verfahrweg of the e-skin
     * @param k_mm The unit K of the e-skin
     * @param aeExcessLength The part which get in to AE
     * @param versatz_mm The Versatz of the Festpunkt
     * @returns The length
     */
    static calcLaenge_mm(verfahrweg_mm, k_mm, aeExcessLength, versatz_mm) {
        return verfahrweg_mm * 0.5 + k_mm + aeExcessLength + Math.abs(versatz_mm);
    }
    /**
     * Calculates the Verfahrweg based on the effective length.
     *
     * @param effektiveLaenge_mm The effective length of the e-skin considering the Teilung
     * @param k_mm The unit k of the e-skin
     * @param versatz_mm The Versatz of the Festpunkt
     * @param aeExcessLength The part which get in to AE
     * @returns the Verfahrweg of the Kette
     */
    static calcVerfahrweg_mm(effektiveLaenge_mm, k_mm, versatz_mm, aeExcessLength) {
        const verfahrweg_mm = 2 * (effektiveLaenge_mm - Math.abs(versatz_mm) - k_mm - aeExcessLength);
        return Math.max(0, verfahrweg_mm);
    }
}
exports.EskinMath = EskinMath;
//# sourceMappingURL=eskin-math.js.map